/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket, MODES } from '../use-order-ticket.js'
import { getId, Flyout } from '../../twd'

const ActionTooltip = `
    Select Buy to purchase a security.<br/>
    Select Sell to sell a security.<br/>
    Select Buy Quote (Offer Wanted) to request a price quote to purchase a security.<br/>
    Select Sell Quote (Bid Wanted) to request a price quote to sell a security.
`

export const SelectAction = () => {
    const { action:action_, setAction, mode, errors, hasBondInfo, noMarketRfq, isTreasuryAuction} = useOrderTicket()

    const canTrade = hasBondInfo
    const isLift = mode === MODES.ORDER_Z
    const isDisabled = !canTrade
    const isReadOnly = isLift || isTreasuryAuction
    const isRqt = mode === MODES.RFQ || noMarketRfq

    const id = getId()
    const err = errors && errors.action

    const action = isTreasuryAuction ? 'B' : action_
    const borderLeftColor = action==='B' || action==='F' ? '#107A1B'
        : action==='S' || action==='W' ? '#CC0000'
        : ''
    const selectStyle = !hasBondInfo || err ?  {}
        : {
            borderLeftWidth: '4px',
            borderLeftColor,
            paddingLeft: '9px',
        }

    const hasBuy = !isRqt || isTreasuryAuction
    const hasSell = !isRqt && !isTreasuryAuction
    const hasBid = !isTreasuryAuction
    const hasAsk = !isTreasuryAuction

    return <React.Fragment>
        <div className="from-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <div style={{lineHeight:'20px', display:'inline', paddingBottom: '2px'}}>
                <div><Flyout
                    label="Action"
                    labelAttrs={{htmlFor:id}}
                    isLabel={true}
                    html={ActionTooltip}
                /></div>
            </div>
            <div className="select-wrapper">
            <div className={err ? ' has-error' : ''}>
            <select
                id={id}
                data-name="order-ticket-account-select"
                defaultValue={action}
                onChange={(e) => setAction(e.target.value)}
                className="form-control"
                readOnly={isReadOnly}
                aria-readonly={isReadOnly}
                disabled={isDisabled || isReadOnly}
                style={selectStyle}
            >
                {isDisabled && <option value="" selected={!action}>Select</option>}
                {hasBuy && <option value="B" selected={action==='B'}>Buy</option>}
                {hasSell && <option value="S" selected={action==='S'}>Sell</option>}
                {hasBid && <option value="W"  selected={action==='W'}>Sell Quote (Bid Wanted)</option>}
                {hasAsk && <option value="F"  selected={action==='F'}>Buy Quote (Offer Wanted)</option>}
            </select>
            </div>
            { err && <label className="field-status has-error">{err}</label> }
            </div>
        </div>
        <div className="col-md-2 col-xs"></div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/order-ticket/form/select-action.js